import React, { FC, useRef } from 'react';

import { adminActions } from '@pharmaplan/common';

import { IListState } from '../../../../../hooks/useTransferList';
import TransferList from '../../../../common/TransferList';
import strings from '../../../../../localization';

import AssignAccountsSearch from './AssignAccountsSearch';
import styles from '../styles';

interface IAssignAccountsTransferList {
  list: IListState;
  setList: React.Dispatch<React.SetStateAction<IListState>>;
}

const AssignAccountsTransferList: FC<IAssignAccountsTransferList> = ({
  list,
  setList,
}) => {
  // The list is fetched whole, so these only satisfy TransferList's contract.
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  return (
    <TransferList
      leftOrnament={<AssignAccountsSearch />}
      leftListStyle={styles.leftList}
      rightListStyle={styles.rightList}
      leftTitle={strings.availablePharmacies}
      rightTitle={strings.assignedPharmacies}
      leftDesc={strings.selectPharmaciesToAssign}
      rightDesc={strings.pharmaciesAssignedToAdmin}
      list={list}
      setList={setList}
      leftRef={leftRef}
      rightRef={rightRef}
      successAction={adminActions.assignPharmacies}
      allowSingle={false}
    />
  );
};

export default AssignAccountsTransferList;
